import type { RouteRecordRaw } from 'vue-router';

export const customerRoutes: RouteRecordRaw = {
  path: '/customer',
  component: () => import('./CustomerLayout.vue'),
  meta: {userType: 'CUSTOMER_PORTAL_USER'},
  children: [
    {
      path: '',
      name: 'customer-home',
      component: () => import('./views/Overview.vue'),
      meta: {crumb: 'Overview'},
    },
    {
      path: 'contacts',
      name: 'customer-contacts',
      component: () => import('./views/Contacts.vue'),
      meta: {crumb: 'Contacts'},
    },
    {
      path: 'calls',
      name: 'customer-calls',
      component: () => import('./views/Calls.vue'),
      meta: {crumb: 'Call history'},
    },
  ],
};
